import { Button } from "../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../components/generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { SearchBar } from "../../components/generic/SearchBar";
import { useState } from "react";
import { UserItem } from "../../components/users/UserItem";
import AdduserModal from "../../components/users/AddUsers";
import { useUsersHook } from "../../hooks/useUsersHook";

const Users = () => {
  const rolepicked = usePickerhook();
  const [entered, setentered] = useState("");
const {allusers}=useUsersHook()

  const [showadduser, setshowadduser] = useState(false);

  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full pr-20  flex  ">
      {showadduser && <AdduserModal show={setshowadduser} />}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Users ({allusers.length})
          </p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add User
              </>
            }
            onBtnClick={() => {
              setshowadduser(true);
            }}
          />
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="flex  gap-2">
            <ListPicker hook={rolepicked} notitle title="Company" list={[]} />
            <ListPicker hook={rolepicked} notitle title="User type" list={[]} />
          </div>
          <SearchBar placeholder="Search" onchange={onChange} value={entered} />
        </div>
        <hr />

        <div className="grid grid-cols-2 mt-4 gap-6">
          {allusers.map((i:any) => (
            <UserItem item={i} />
          ))}
        </div>
      </div>
    </div>
  );
};
export { Users };
